import { Badge } from "@qw/ui";
import { Link, type LinkProps, useParams } from "react-router";
import { usePage } from "../providers/use-page";

export const BankanCard = ({
  children,
  id,
  name,
  remaining,
  ...props
}: Omit<LinkProps, "to"> & { id: string; name: string; remaining: number }) => {
  const { column } = useParams();
  const { rootPath } = usePage();
  return (
    <div>
      <Link
        to={{ pathname: `${rootPath}/${id}`, search: `?column=${column}&labels=` }}
        className="group bg-muted block p-1 rounded-md space-y-1"
        {...props}
      >
        <div className="flex font-semibold h-7 items-center px-3 text-sm">
          <span className="truncate">{name}</span>
        </div>
        <div className="relative space-y-px">
          {children}
          {!!remaining && (
            <Badge variant="primary" type="square" size="2xs" className="absolute top-2 right-2">
              +{remaining}
            </Badge>
          )}
        </div>
      </Link>
    </div>
  );
};
